import React from 'react';
import { Image, ImageProps } from '@components/Images/Image';

export const WorldImage: React.FC<ImageProps> = (props) => (
  <Image
    src="/images/world.png"
    className="relative z-10 object-contain max-w-[600px] rounded-full shadow-md"
    {...props}
  />
);
